const LAYOUT_WITH_SUBGRADES = "with_subgrades";
const LAYOUT_SIMPLE = "simple";

const pickLayout = (scenario) =>
  scenario === LAYOUT_WITH_SUBGRADES ? LAYOUT_WITH_SUBGRADES : LAYOUT_SIMPLE;

export {
  LAYOUT_WITH_SUBGRADES,
  LAYOUT_SIMPLE,
  pickLayout
};
